import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  organizationResourceFeedFragment,
  organizationChildResourceFragment,
  organizationResourceFragment,
} from "./OrganizationResourcesFragments";

import {
  getOrganizationResourcesBasicDetailsQuery,
  getOrganizationSyncStatusQuery,
} from "./OrganizationResourcesQuery";
import { getPlannerOrganizationResourcesOfNodeQuery } from "Teacher/routes/Courses/routes/Course/routes/UnitPlans/modules/UnitPlanQuery";
import { plannerOrganizationResourceNodeFragment } from "UnitPlans/modules/UnitPlanFragments";

const resourcesFragmentMap = {
  ORGANIZATION: {
    typeName: "Organization",
    fragment: organizationResourceFeedFragment.organizationResourceFeed,
    fragmentName: "organizationResourceFeedItem",
  },
  UNIT_PLAN: {
    typeName: "UnitPlan",
    fragment: organizationResourceFeedFragment.unitPlanResourceFeed,
    fragmentName: "unitPlanResourceFeedItem",
  },
  UNIT_PLAN_V2: {
    typeName: "UnitPlan",
    fragment: organizationResourceFeedFragment.unitPlanResourceFeedV2,
    fragmentName: "unitPlanResourceFeedItem",
  },
  ASSESSMENT: {
    typeName: "Assessment",
    fragment:
      plannerOrganizationResourceNodeFragment.assessmentOrganizationResourceNode,
    fragmentName: "assessmentOrganizationResourceNodeItem",
  },
  COURSE: {
    typeName: "Course",
    fragment: organizationResourceFeedFragment.studentDriveResourceFeed,
    fragmentName: "studentDriveResourceFeedItem",
  },
};

export const getOrganizationResourceFromCache = ({ id }) => {
  let queryData = {};

  try {
    queryData = client.readFragment({
      id: `OrganizationResource:${id}`,
      fragment: organizationResourceFragment.organizationResource,
      fragmentName: "organizationResourceItem",
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return queryData;
  else return {};
};

export const getOrganizationResourcesFromCache = ({
  filters,
  parentType,
  parentId,
  orderBy,
  orderByDirection,
  organizationResourceFilter,
  isUnitFlow,
  first,
}) => {
  let queryData = {};
  const { typeName, fragment, fragmentName } = resourcesFragmentMap[parentType];
  try {
    queryData = client.readFragment({
      id: `${typeName}:${parentId}`,
      fragment,
      fragmentName,
      variables: {
        ...filters,
        first,
        orderBy,
        orderByDirection,
        organizationResourceFilter,
        isUnitFlow,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const writeOrganizationResourcesInCache = ({
  filters,
  data,
  parentType,
  parentId,
  orderBy,
  orderByDirection,
  organizationResourceFilter,
  isUnitFlow,
  first,
}) => {
  const { typeName, fragment, fragmentName } = resourcesFragmentMap[parentType];
  try {
    client.writeFragment({
      id: `${typeName}:${parentId}`,
      fragment,
      fragmentName,
      variables: {
        ...filters,
        first,
        orderBy,
        orderByDirection,
        organizationResourceFilter,
        isUnitFlow,
      },
      data,
    });
  } catch (e) {
    console.error(e);
  }
};

export const getChildResourcesFromCache = ({
  id,
  searchText,
  visibleTo,
  filters,
  orderBy,
  orderByDirection,
}) => {
  let queryData = {};

  try {
    queryData = client.readFragment({
      id: `OrganizationResource:${id}`,
      fragment: organizationChildResourceFragment.childResourceFragment,
      fragmentName: "organizationChildResourceItem",
      variables: {
        searchText,
        visibleTo,
        filters,
        orderBy,
        orderByDirection,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const writeChildResourcesInCache = ({
  id,
  searchText,
  visibleTo,
  filters,
  orderBy,
  orderByDirection,
  data,
}) => {
  try {
    client.writeFragment({
      id: `OrganizationResource:${id}`,
      fragment: organizationChildResourceFragment.childResourceFragment,
      fragmentName: "organizationChildResourceItem",
      variables: {
        searchText,
        visibleTo,
        filters,
        orderBy,
        orderByDirection,
      },
      data,
    });
  } catch (e) {
    console.error(e);
  }
};

export const getOrganizationResourcesBasicDetailsFromCache = ({
  parentId,
  filters,
  parentType,
  types,
  visibleTo,
  resourceType,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationResourcesBasicDetailsQuery,
      variables: {
        parentId,
        filters,
        parentType,
        types,
        visibleTo,
        resourceType,
      },
    });
  } catch (e) {
    return queryData;
  }

  return queryData;
};

export const getOrganizationSyncStatusFromCache = syncStatusVariable => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationSyncStatusQuery,
      variables: {
        ...syncStatusVariable,
      },
    });

    return queryData ? _.get(queryData, "node", {}) : {};
  } catch (e) {
    return {};
  }
};

export const writePlannerOrganizationResourcesOfNodeToCache = ({
  variables,
  data,
}) => {
  try {
    client.writeQuery({
      query: getPlannerOrganizationResourcesOfNodeQuery,
      variables,
      data,
    });
  } catch (err) {
    console.error(err);
  }
};
